import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MaskedInput from "../../../../controls/MaskedInput";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

class CompanyContactRow extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        onUpdate: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        name: this.props.data.name,
        phoneNumber: this.props.data.phoneNumber
            ? this.props.data.phoneNumber.substr(2, this.props.data.phoneNumber.length - 2)
            : this.props.data.phoneNumber,
        initialEmail: this.props.data.email,
        email: this.props.data.email,
        isUser: this.props.data.isUser,
        isOtherCompanyUser: this.props.data.isOtherCompanyUser,
        isReceiveEmailNotification: this.props.data.isReceiveEmailNotification
    };

    render() {
        const {onRemove} = this.props;
        return (
            <tr>
                <td>
                    <input type="text" className="form-control"
                           placeholder="Контактное лицо"
                           value={this.state.name}
                           onChange={event => this.updateState({name: event.target.value})}/>
                </td>
                <td>
                    <div className="input-group">
                        <div className="input-group-addon">
                            <span className="flag-icon flag-icon-ru"/> +7
                        </div>
                        <MaskedInput type="text" className="form-control"
                                     placeholder="Телефон"
                                     mask="(999) 999-9999"
                                     value={this.state.phoneNumber}
                                     onChange={event => this.updateState({phoneNumber: event.target.value})}/>
                    </div>
                </td>
                <td>
                    <input type="email" className="form-control"
                           placeholder="Email"
                           value={this.state.email}
                           onChange={event => this.updateState({email: event.target.value})}/>
                </td>
                <td>
                    {
                        this.state.isOtherCompanyUser && this.state.email === this.state.initialEmail
                            ? (
                                <OverlayTrigger placement="top"
                                                overlay={
                                                    <Tooltip id="reload-grid-data-tooltip">
                                                        Данный пользователь принадлежит другой компании
                                                    </Tooltip>}>
                                    <label className="checkbox-inline">
                                        <input type="checkbox"
                                               disabled={true}
                                               checked={this.state.isUser}
                                               onChange={event => this.updateState({isUser: event.target.checked})}/>
                                        &nbsp;Пользователь
                                    </label>
                                </OverlayTrigger>
                            )
                            : (
                                <label className="checkbox-inline">
                                    <input type="checkbox"
                                           checked={this.state.isUser}
                                           onChange={event => this.updateState({isUser: event.target.checked})}/>
                                    &nbsp;Пользователь
                                </label>
                            )
                    }
                    <br/>
                    <label className="checkbox-inline">
                        <input type="checkbox"
                               checked={this.state.isReceiveEmailNotification}
                               onChange={event => this.updateState({isReceiveEmailNotification: event.target.checked})}/>
                        &nbsp;Отправлять email уведомления
                    </label>
                </td>
                <td>
                    <button type="button" className="btn btn default btn-outline"
                            onClick={() => onRemove()}>
                        <i className="fa fa-close"/>
                    </button>
                </td>
            </tr>
        );
    }

    updateState(state) {
        const {onUpdate} = this.props;

        this.setState(state, () => {
            const {...formData} = this.state;

            formData.phoneNumber = `7 ${formData.phoneNumber}`;

            onUpdate(formData);
        });
    }
}

export default CompanyContactRow;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Companies/components/CompanyContactRow.js